import { Pipe, PipeTransform } from '@angular/core';
export class TdBytesPipe implements PipeTransform {
/**
 * @param {?} bytes
 * @param {?=} precision
 * @return {?}
 */
transform(bytes: any, precision: number = 2): string {
    if (bytes === 0) {
      return '0 B';
    } else if (isNaN(parseInt(bytes, 10))) {
      /* If not a valid number, return 'Invalid Number' */
      return 'Invalid Number';
    }
    let /** @type {?} */ k: number = 1024;
    let /** @type {?} */ sizes: string[] = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let /** @type {?} */ i: number = Math.floor(Math.log(bytes) / Math.log(k));
    // if less than 1
    if (i < 0) {
      return 'Invalid Number';
    }
    return parseFloat((bytes / Math.pow(k, i)).toFixed(precision)) + ' ' + sizes[i];
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'bytes',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TdBytesPipe_tsickle_Closure_declarations() {
/** @type {?} */
TdBytesPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdBytesPipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
